const ISSUE_CODE = (exports.ISSUE_CODE = {
  UNEXPECTED_DELAY: 0,
  FIRE: 1,
  FLOOD: 2,
  SNOW: 3,
  CIVIL_UNREST: 4,
  NO_SAILING: 5,
  TRAFFIC_INCIDENT: 6,
  HIGH_WINDS: 7,
  FLIGHT_DELAY: 8,
  OLYMPIC_DELAY: 9,
  LOCAL_EVENT: 10,
  CORONAVIRUS: 11,
});

exports.ISSUE_NAME = {
  [ISSUE_CODE.UNEXPECTED_DELAY]: "Unexpected Delay",
  [ISSUE_CODE.FIRE]: "Fire",
  [ISSUE_CODE.FLOOD]: "Flood",
  [ISSUE_CODE.SNOW]: "Snow",
  [ISSUE_CODE.CIVIL_UNREST]: "Civil Unrest",
  [ISSUE_CODE.NO_SAILING]: "No Sailing",
  [ISSUE_CODE.TRAFFIC_INCIDENT]: "Traffic Incident",
  [ISSUE_CODE.HIGH_WINDS]: "High Winds",
  [ISSUE_CODE.FLIGHT_DELAY]: "Flight Delay",
  [ISSUE_CODE.OLYMPIC_DELAY]: "Olympic Delay",
  [ISSUE_CODE.LOCAL_EVENT]: "Local Event",
  [ISSUE_CODE.CORONAVIRUS]: "Coronavirus",
};
